module.exports = __webpack_public_path__ + "static/media/SambazaHub.8e072ba3.webp";